import React from 'react';

interface ChatDateDividerProps {
  date?: Date;
  locale: string;
  label: string;
}

/** Marks where a conversation sits in time, above the first message. */
const ChatDateDivider: React.FC<ChatDateDividerProps> = ({ date = new Date(), locale, label }) => (
  <p className="py-4 text-center text-xs font-medium text-muted-foreground">
    {date.toLocaleDateString(locale, { weekday: 'long', month: 'short', day: 'numeric' })}
    {` ・ ${label}`}
  </p>
);

export default ChatDateDivider;
